module.exports = __webpack_public_path__ + "static/img/to_country_game.3baa1e7d.png";